import reportKey from './ReportKey';

export default [reportKey];
